import { render } from "./ErrorWarningMessage.vue?vue&type=template&id=4a3ad394&scoped=true"
import script from "./ErrorWarningMessage.vue?vue&type=script&lang=js"
export * from "./ErrorWarningMessage.vue?vue&type=script&lang=js"

import "./ErrorWarningMessage.vue?vue&type=style&index=0&id=4a3ad394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3ad394"]])

export default __exports__